import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TPVServices } from '../../../tpv/services';
import { OrdersCoServices } from '../../services';

/**
 * Generated class for the TpvTicketSelectedListTicketPrintPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

/**
 * tpvServices.ticket_print -> seleccionamos si normal o invidual
 *
 * NORMAL
 *-------
 * globals -> informacion del restaurante ademas del header y footer
 * tpvServices.tables_array.ticket -> informacion basica del ticket como la fecha
 * selected_list -> lista de platos menus... del ticket
 *
 * INV
 *-------
 * globals -> informacion del restaurante ademas del header y footer
 * tpvServices.ticket_print_ind_number y ticket_print_ind_date -> informacion basica del ticket
 * tpvServices.ticket_print_ind -> toda la informacion del ticket
 * tpvServices.subtotal_ticket_indv_print -> subtotal del ticket
 * tpvServices.total_ticket_indv_print -> total del ticket
 * */

@Component({
    selector: 'page-orders-table-tpv-ticket-print',
    templateUrl: 'orders-table-tpv-ticket-print.html',
})
export class OrdersTableTpvTicketPrintPage {
    @Input() selected_list: any;
    footer: any;
    header: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public tpvServices: TPVServices,
        public ordersCoServices: OrdersCoServices) {
    }

    calculateVariations(units, price, variation_add) {
        return (parseFloat(units) * parseFloat(price)) + parseFloat(variation_add)

    }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-table/orders-table-tpv-ticket-print/orders-table-tpv-ticket-print.ts